import { useMemo, useState } from "react";

import { Button, CloseSVG, DottedMenuSVG, Icon } from "@newsela/angelou";

import { menuButtonCss } from "@/base/NewselaGlobalLayoutV2/NavigationBar/AppSwitcherMenu/AppSwitcherMenu.styles";
import { AppSwitcherPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/AppSwitcherMenu/AppSwitcherPopout";
import { NavButtonWithPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout";
import {
  getNavMenuButtonAriaProps,
  IButtonAriaProps,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout/NavButtonWithPopout.utils";
import useIsImraUser from "@/imra/useIsImraUser";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

const MENU_ID = "global-nav-app-switcher";

const AppSwitcherMenu = () => {
  const { data: user } = useUser();
  const { canSeeFormative, canSeeEverwrite } = getUserProperties(user, {
    shouldUseNewUserApi: false,
  });

  const isImraUser = useIsImraUser();

  const [isOpen, setIsOpen] = useState(false);

  const buttonAriaProps: IButtonAriaProps = useMemo(
    () =>
      getNavMenuButtonAriaProps({
        isOpen,
        id: MENU_ID,
        ariaLabel: "App Switcher Menu",
      }),
    [isOpen],
  );

  if (isImraUser) return null;

  return (
    <NavButtonWithPopout
      id={MENU_ID}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      position={{ left: 0, top: "3.8rem" }}
      ButtonComponent={
        <Button
          __cssFor={menuButtonCss}
          ariaProps={buttonAriaProps}
          disabled={!canSeeFormative && !canSeeEverwrite}
          flavor={Button.flavors.incognito}
          onClick={() => setIsOpen((isOpen) => !isOpen)}
          dataProps={{
            "data-qa-selector": "global-nav-app-switcher",
            tabIndex: 0,
          }}
        >
          {isOpen ? (
            <Icon SvgComponent={CloseSVG} />
          ) : (
            <Icon SvgComponent={DottedMenuSVG} />
          )}
        </Button>
      }
      PopoutComponent={<AppSwitcherPopout setIsOpen={setIsOpen} />}
    />
  );
};

AppSwitcherMenu.displayName = "AppSwitcherMenu";
export { AppSwitcherMenu };
